"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeScope = exports.ObjectScope = exports.Scope = void 0;
class Scope {
    constructor(name) {
        this.name = name;
    }
}
exports.Scope = Scope;
class ObjectScope extends Scope {
    constructor(name) {
        super(name);
        this.properties = {};
    }
    addProperty(key, value) {
        this.properties[key] = value;
    }
}
exports.ObjectScope = ObjectScope;
class TimeScope extends Scope {
    constructor(name) {
        super(name);
        this.statements = [];
    }
    addStatement(verb, args) {
        this.statements.push({ verb, args });
    }
}
exports.TimeScope = TimeScope;
